<template>
  <div class="p-8">
    <h2>SmartTimeRangePanel 测试界面</h2>
    <div class="mb-4">
      <smart-time-range-panel v-model="range" />
    </div>
    <el-button type="primary" @click="setDefaultRange"
      >设置默认日期区间</el-button
    >
    <el-button class="ml-2" @click="getRange">获取当前区间</el-button>
    <div class="mt-4">
      <strong>当前区间：</strong>
      <span>{{ rangeText }}</span>
    </div>
  </div>
</template>

<script>
import SmartTimeRangePanel from "@/components/SmartControls/TimeRangePanel/SmartTimeRangePanel.vue";

export default {
  name: "DemoDateRangePanel",
  components: {
    SmartTimeRangePanel,
  },
  data() {
    return {
      range: null,
      rangeText: "",
    };
  },
  methods: {
    setDefaultRange() {
      this.range = [new Date(2025, 8, 1), new Date(2025, 8, 8)];
    },
    getRange() {
      if (Array.isArray(this.range) && this.range[0] && this.range[1]) {
        this.rangeText = `${this.range[0]} ~ ${this.range[1]}`;
      } else {
        this.rangeText = "未选择";
      }
    },
  },
};
</script>
